import { Box, Button } from "@mui/material";
import { CSSProperties, useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const MobileBtn = () => {
	const { state, actions, theme } = useContext(Context);
	const { translate } = useLocales();

	const buttonStyle: CSSProperties = {
		borderRadius: theme?.button.shape,
		backgroundColor: theme?.colors.buttonBackground,
		color: theme?.colors.buttonText,
		fontWeight: theme?.button.textWeight === "BOLD" ? 700 : 500
	};

	return (
		<Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
			<Button
				variant='contained'
				size='medium'
				onClick={() => actions.setStep(state.entity?.id ? 2 : 1)}
				style={buttonStyle}
			>
				{translate("info_panel.connect_my_account")}
			</Button>
		</Box>
	);
};

export default MobileBtn;
